import dayjs from 'dayjs';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function formatCurrencyUSD(cents: number): string {
  const dollars = cents / 100;
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(Math.abs(dollars));
  return cents < 0 ? `-${formatted}` : formatted;
}

export function formatIsoDate(iso: string): string {
  return dayjs(iso).format('MM/DD/YYYY');
}

export function formatPhoneUS(input: string): string {
  const parsed = parsePhoneNumberFromString(input, 'US');
  return parsed?.isPossible() ? parsed.formatNational() : input;
}
